/* eslint-disable @next/next/no-img-element */
import React, { ReactNode } from 'react';
import Container from '@amf/shared/components/layout/Container';
import classNames from 'classnames';

interface HeaderProps {
  title: ReactNode;
  photoUrl?: string;
  children?: ReactNode;
  titleClassName?: string;
  className?: string;
}

function Header({ title, photoUrl, children, titleClassName, className }: HeaderProps) {
  return (
    <div className='Header'>
      {photoUrl && <img src={photoUrl} alt={title as string} className='Header__photo' />}
      <div className='Header__overlay'>
        <Container className='Header__container'>
          <div className='Header__content'>
            <div className='Header__crosses'>
              <div className='Header__cross' />
              <div className='Header__cross' />
              <div className='Header__cross' />
              <div className='Header__cross' />
              <div className='Header__cross' />
            </div>
            <h1 className={classNames('Header__title', titleClassName)}>{title}</h1>
            {children && <div className='Header__children'>{children}</div>}
          </div>
        </Container>
      </div>
    </div>
  );
}

export default Header;
